import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, Alert, Card, CardBody } from 'reactstrap';
import { BASE_URL } from '../../../constants';

function AddArea(props) {

    const [errMsg, setErrMsg] = useState(null);
    const [title, setTitle] = useState('');
    const [isCommon, setIsCommon] = useState(0);
    const [isCustom, setIsCustom] = useState(0);
    const [isAdded, setIsAdded] = useState(false);
    const navigate = useNavigate();
    const [newAreaId, setNewAreaId] = useState(null);

    console.log(isCommon, 'isCommon')

    const handleSubmit = async (e) => {
        e.preventDefault();

            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('Authorization token is missing.');
                }

                const response = await axios.post(`${BASE_URL}/area/add`, {
                    title,
                    is_common: isCommon,
                    // is_custom: isCustom
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (response.data.status) {
                    const newArea = response.data.result;
                    setNewAreaId(response.data.result.id);
                    setIsAdded(true);

                    navigate(`/area/edit/${newArea.id}`, {
                        state: {
                            areas: [newArea] 
                        }
                    });
                } else {
                    setErrMsg(response.data.message);
                }
            } catch (error) {
                setErrMsg(error);
            }
        
    };

    // if (isAdded && newAreaId) {
    //     navigate(`/area/edit/${newAreaId}`, {
    //         state: {
    //             areas: areas
    //         }
    //     });
    // }

    return (
        <div className="content">
            {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

            <h3>Add Amenity</h3>
            <Card>
                <CardBody>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                            <Label for="title">Title*</Label>
                            <Input type="text" name="title" id="title" value={title} onChange={(e) => setTitle(e.target.value)} />
                        </FormGroup>
                        <div style={{ paddingLeft: '10px', paddingRight: '10px', marginTop: '10px' }}>
                            <Label check>
                                <Input type="checkbox" checked={isCommon} onChange={(e) => setIsCommon(e.target.checked ? 1 : 0)} />{' '}
                                Is Common
                            </Label>

                        </div>

                        {/* <FormGroup check style={{ paddingLeft: '10px', paddingRight: '10px' }}> */}
                        {/* <div style={{ paddingLeft: '10px', paddingRight: '10px', marginTop: '10px' }}>
                            <Label check>
                                <Input type="checkbox" checked={isCustom} onChange={(e) => setIsCustom(e.target.checked ? 1 : 0)} />{' '}
                                Is Custom
                            </Label>
                        </div> */}
                        {/* </FormGroup> */}

                        <Button color="primary" type="submit">Submit</Button>
                    </Form>
                </CardBody>
            </Card>

        </div>
    );
}

export default AddArea;
